(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function hydrate(slide) {
      if (!slide) return;
      var img = slide.querySelector('img[data-src]');
      if (!img) return;
      img.src = img.dataset.src;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }

    document.querySelectorAll('.hero__carousel').forEach(function(track) {
      var slides = track.querySelectorAll('.hero__slide');
      if (slides.length === 0) return;

      if (slides.length > 1) {
        var idlePreload = window.requestIdleCallback || function(cb) { setTimeout(cb, 600); };
        idlePreload(function() { hydrate(slides[1]); });
      }

      if (slides.length <= 1) return;

      var section = track.closest('.hero');
      var dots = section ? section.querySelectorAll('.hero__dot') : [];
      var current = 0;
      var timer = null;

      function goTo(index) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = (index + slides.length) % slides.length;
        hydrate(slides[current]);
        hydrate(slides[(current + 1) % slides.length]);
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      function next() { goTo(current + 1); }
      function start() { stop(); timer = setInterval(next, 4500); }
      function stop() { if (timer) clearInterval(timer); }

      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() { goTo(i); start(); });
      });

      section.addEventListener('mouseenter', stop);
      section.addEventListener('mouseleave', start);

      start();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
